import { Text } from "@/components/ui";
import { StatuteConfirmedIcon } from "@/components/ui/Icons/StatuteConfirmedIcon";
import { cn } from "@/lib/utils/cn";
import { toCompactDate } from "@/lib/utils/matters/matter-compact-date";
import { getStatuteDateDisplayClassName } from "@/lib/utils/matters/statute-urgency-utils";

/**
 * SOL / statute column: compact date + urgency coloring ({@link getStatuteDateDisplayClassName}) + confirmed icon.
 * Shared by My Matters dashboard and the matters report table.
 */
export function CompactStatuteDateCell({
  statuteDate,
  confirmed,
}: {
  statuteDate?: string | null;
  confirmed?: boolean | null;
}) {
  if (!statuteDate) {
    return "-";
  }
  return (
    <div className="inline-flex items-center gap-2">
      <Text
        as="span"
        variant="body"
        className={cn(
          "font-semibold",
          getStatuteDateDisplayClassName(statuteDate),
        )}
      >
        {toCompactDate(statuteDate)}
      </Text>
      <StatuteConfirmedIcon confirmed={confirmed} />
    </div>
  );
}
